/* eslint-disable */
export default {
  dial: 'Composer',
  message: 'Message',
  transfer: 'Transférer',
} as const;

// @key: @#@"dial"@#@ @source: @#@"Dial"@#@
// @key: @#@"message"@#@ @source: @#@"Message"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
